"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InvitationOverview() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: subheadRef,
    isVisible: subheadVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233968" id="hero" className="relative flex min-h-[90vh] w-full items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.05] transition-transform duration-75 ease-linear" style={{
      transform: `translateY(${scrollY * 0.15}px)`
    }} aria-hidden="true">
        <svg viewBox="0 0 200 200" className="h-[150%] w-[150%] max-w-none fill-primary md:h-[120%] md:w-[120%]" xmlns="http://www.w3.org/2000/svg">
          {}
          <path d="M100 0 C120 40 160 60 200 100 C160 140 120 160 100 200 C80 160 40 140 0 100 C40 60 80 40 100 0 Z M100 40 C110 70 140 85 160 100 C140 115 110 130 100 160 C90 130 60 115 40 100 C60 85 90 70 100 40 Z" />
          <path d="M100 20 C115 50 150 65 180 100 C150 135 115 150 100 180 C85 150 50 135 20 100 C50 65 85 50 100 20 Z" opacity="0.5" />
        </svg>
      </div>

      {}
      <div className="relative z-10 flex max-w-5xl flex-col items-center px-6 text-center">
        <div ref={headlineRef} className={`transition-all duration-1000 ease-out ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h1 className="font-default text-6xl font-bold leading-tight text-foreground md:text-[64px]">
            Portfólio de Produção Audiovisual e Podcast
          </h1>
        </div>

        <div ref={subheadRef} className={`mt-8 transition-all duration-1000 ease-out delay-300 ${subheadVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <p className="font-default text-lg font-normal leading-relaxed text-muted-foreground md:text-xl">
            Conheça alguns dos projetos desenvolvidos pela ITC+ em São Paulo, com foco em qualidade, posicionamento e resultado.
          </p>
        </div>

        <div ref={ctaRef} className={`mt-16 transition-all duration-1000 ease-out delay-500 ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild variant="default" size="lg" className="rounded-full bg-primary px-10 py-6 font-default text-base font-medium tracking-wide text-primary-foreground transition-all duration-300 hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/20">
            <Link to="https://wa.me/5511969100007">Falar no WhatsApp</Link>
          </Button>
        </div>
      </div>
    </section>;
}